import React, { Component } from 'react';
import {Helmet} from "react-helmet";

//Import Component
import NavBar from "../components/NavBar";
import Banner from "../components/banner/Banner";
import Services from "../components/Services";
import About from "../components/About";
import Reports from "../components/Reports";
import VideoArea from "../components/VideoArea";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

class Home extends Component {
  render() {
    return (
        <React.Fragment>
            <Helmet>
              <meta charSet="utf-8" />
              <title>Casa Maria</title>
              <link rel="canonical" href="http://www.casa-varstnici-maria.ro" />
            </Helmet>
            <NavBar pageName="home" />
            <Banner />
            <Services />
            <About />
            <Reports />
            <VideoArea />
            <Contact />
            <Footer />
        </React.Fragment>
    );
  }
}

export default Home;
